export default __webpack_public_path__ + "static/media/dribbble.d2564ac1.gif";